import { Params } from '@angular/router';

export interface State {
  url: string | null;
  queryParams: Params | null;
}

export const initialState: State = {
  url: null,
  queryParams: null,
};
